import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { Reveal } from "./ui";
import { Testimonial } from "./data";

/** Single interleaved testimonial, meant to be dropped between sections. */
export function TestimonialCard({
  t
}: {
  t: Testimonial;
}) {
  return <section className="w-full px-4 py-5 sm:px-8 sm:py-8" data-id="element-246" data-mp="2p7om9jr4dlyq">
      <Reveal className="mx-auto max-w-3xl" data-id="element-247" data-mp="2p99f94xscwuh">
        <figure className="relative rounded-2xl border border-[#e6eef5] bg-white p-4 shadow-[0_18px_50px_-24px_rgba(31,51,69,0.4)] sm:rounded-3xl sm:p-8" data-id="element-248" data-mp="2u71i2tzyy3dg">
          <QuoteIcon className="absolute right-6 top-6 h-8 w-8 text-[var(--calm-blue)]" aria-hidden data-id="element-249" data-mp="2z41d89va5lps" />
          <div className="mb-3 flex text-[#f0b429]" data-id="element-250" data-mp="386kbshs19c68">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-251" data-mp="19r7qg08wok26" data-mpi={i} />)}
          </div>
          <blockquote className="font-serif-display text-base leading-relaxed text-[var(--ink)] sm:text-xl" data-id="element-252" data-mp="1ds00uwtikv01">
            “{t.text}”
          </blockquote>
          <figcaption className="mt-3 flex items-center justify-center gap-2 sm:mt-5 sm:justify-start sm:gap-3" data-id="element-253" data-mp="huxj1xvr7avx">
            <img src={t.avatar} alt={`${t.name}, ${t.province}`} className="h-12 w-12 rounded-full object-cover" loading="lazy" data-id="element-254" data-mp="d09szul3q8f8" />
            <div data-id="element-255" data-mp="323snhey1ach">
              <div className="text-sm font-bold text-[var(--ink)]" data-id="element-256" data-mp="10rf8g8n4qyp0">{t.name}</div>
              <div className="text-xs text-[var(--muted)]" data-id="element-257" data-mp="vsm2r2e34bze">{t.province}</div>
            </div>
          </figcaption>
        </figure>
      </Reveal>
    </section>;
}